import React from "react";

export const AdminPageShell = ({
  eyebrow = "Admin workspace",
  title,
  description,
  actions,
  children,
}) => {
  return (
    <div className="roha-admin-page">
      <section className="roha-admin-page__hero">
        <div className="roha-admin-page__copy">
          <p className="roha-admin-page__eyebrow">{eyebrow}</p>
          <h2>{title}</h2>
          {description ? <p className="roha-admin-page__description">{description}</p> : null}
        </div>
        {actions ? <div className="roha-admin-page__actions">{actions}</div> : null}
      </section>
      <div className="roha-admin-page__body">{children}</div>
    </div>
  );
};

export const AdminSurface = ({ title, subtitle, actions, children, className = "" }) => {
  return (
    <section className={`roha-admin-surface ${className}`.trim()}>
      {(title || subtitle || actions) && (
        <div className="roha-admin-surface__header">
          <div>
            {title ? <h3>{title}</h3> : null}
            {subtitle ? <p>{subtitle}</p> : null}
          </div>
          {actions ? <div className="roha-admin-surface__actions">{actions}</div> : null}
        </div>
      )}
      {children}
    </section>
  );
};

export default AdminPageShell;
